class CancelFlow extends HTMLElement {
  connectedCallback() {
    this.cacheDomElements();
    this.setupEventListeners();
    this.gateOnActiveSubscription();
  }

  async gateOnActiveSubscription() {
    try {
      await this.waitForRecharge();
      const session = await window.recharge.auth.loginShopifyAppProxy();
      const res = await window.recharge.subscription.listSubscriptions(session, { status: 'active' });
      if (!res?.subscriptions?.length) {
        window.location.replace('/');
        return;
      }
      this.removeAttribute('data-checking-subscription');
    } catch (e) {
      console.error('Cancel flow subscription check failed:', e);
      window.location.replace('/');
    }
  }

  waitForRecharge() {
    return new Promise((resolve, reject) => {
      if (typeof window.recharge !== 'undefined' && window._rechargeInitialized) return resolve();
      const start = Date.now();
      const interval = setInterval(() => {
        if (typeof window.recharge !== 'undefined' && window._rechargeInitialized) {
          clearInterval(interval);
          resolve();
        } else if (Date.now() - start > 10000) {
          clearInterval(interval);
          reject(new Error('Recharge SDK did not initialize in time'));
        }
      }, 100);
    });
  }

  cacheDomElements() {
    this.pages = [...this.querySelectorAll('[js-cancel-flow="page"]')];
    this.showPageButtons = [...this.querySelectorAll('[js-cancel-flow="show-page"]')];
    this.loseSavingsButton = this.querySelector('[js-cancel-flow="lose-savings"]');
  }

  setupEventListeners() {
    this.showPageButtons.forEach(btn => {
      btn.addEventListener('click', this.handleShowPage.bind(this));
    });
    this.loseSavingsButton?.addEventListener('click', this.handleLoseSavings.bind(this));
  }

  disconnectedCallback() {
    this.showPageButtons.forEach(btn => {
      btn.removeEventListener('click', this.handleShowPage.bind(this));
    });
    this.loseSavingsButton?.removeEventListener('click', this.handleLoseSavings.bind(this));
  }

  handleShowPage(e) {
    const pageNum = e.currentTarget.dataset.page;
    this.pages.forEach(p => { p.style.display = 'none'; });
    const target = this.querySelector(`#page-${pageNum}`);
    if (target) target.style.display = 'block';
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  async handleLoseSavings() {
    const btn = this.loseSavingsButton;
    const originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'LOADING\u2026';

    try {
      if (typeof window.recharge === 'undefined' || !window._rechargeInitialized) {
        throw new Error('Recharge SDK not loaded or not initialized');
      }

      const session = await window.recharge.auth.loginShopifyAppProxy();

      const res = await window.recharge.subscription.listSubscriptions(session, { status: 'active' });
      const subscription = res?.subscriptions?.[0];
      if (!subscription) {
        throw new Error('No active subscription found');
      }

      const cancelUrl = await window.recharge.customer.getActiveChurnLandingPageURL(
        session,
        subscription.id,
        '/pages/bundle-manager',
      );

      window.location.href = cancelUrl;
    } catch (e) {
      console.error('Cancel flow redirect failed:', e);
      btn.disabled = false;
      btn.textContent = originalText;
      alert('Something went wrong. Please email support@simmereats.com to cancel, or try again.');
    }
  }
}

customElements.define('cancel-flow', CancelFlow);
